import * as Yup from "yup";

export const LenderMonthlyInterestValidation = ({
  isFunction,
}: {
  isFunction: (...values: never[]) => boolean;
}) =>
  Yup.number()
    .when("amortizationMethod", {
      is: isFunction,
      then: (schema) =>
        schema
          .required("Interest rate is required")
          .typeError("Interest rate is required")
          .positive("Interest rate can't be 0 or negative")
          .max(
            100,
            (schema) => `Interest rate can't be greater than ${schema.max}%`,
          ),
      otherwise: (schema) => schema.nullable(),
    })
    .transform((value) => (isNaN(value) ? undefined : value));
